import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '@app/hooks';
import { makeRequest } from '@app/utils';

export const useCreateAccountMutation = () =>
  useMutation([queryKeys.createAccount], (data: FormData) =>
    makeRequest({
      url: '/opac-users/email-registration',
      method: 'POST',
      data,
    })
  );
